<template>
  <div class="kpi-strip">
    <div class="kpi-group kpi-group--left">
      <div class="kpi">
        <div class="kpi-value">{{ kpis.total }}</div>
        <div class="kpi-label">Devices</div>
      </div>
      <a-divider type="vertical" class="kpi-divider" />
      <div class="kpi">
        <div class="kpi-value">
          <span class="dot dot--online" />{{ kpis.online }}
        </div>
        <div class="kpi-label">Online</div>
      </div>
      <div class="kpi">
        <div class="kpi-value">
          <span class="dot dot--guidance" />{{ kpis.guidance }}
        </div>
        <div class="kpi-label">Guidance</div>
      </div>
      <div class="kpi">
        <div class="kpi-value">
          <span class="dot dot--recording" />{{ kpis.recording }}
        </div>
        <div class="kpi-label">Recording</div>
      </div>
      <div class="kpi">
        <div class="kpi-value">
          <span class="dot dot--offline" />{{ kpis.offline }}
        </div>
        <div class="kpi-label">Offline</div>
      </div>
    </div>

    <div class="kpi-group kpi-group--right">
      <div class="kpi">
        <div class="kpi-value">{{ formatNumber(kpis.cyclesToday) }}</div>
        <div class="kpi-label">Cycles today</div>
      </div>
      <a-divider type="vertical" class="kpi-divider" />
      <div class="kpi">
        <div class="kpi-value">
          {{ formatNumber(kpis.badToday) }}
          <span class="kpi-sub">({{ formatPct(kpis.badPct) }})</span>
        </div>
        <div class="kpi-label">Bad cycles</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    kpis: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  methods: {
    formatNumber(n) {
      const v = Number(n);
      if (!Number.isFinite(v)) return '0';
      return v.toLocaleString();
    },
    formatPct(v) {
      if (!Number.isFinite(v)) return '0%';
      return `${v.toFixed(1)}%`;
    },
    formatMoney(v) {
      const n = Number(v);
      if (!Number.isFinite(n) || n <= 0) return '$0';
      if (n >= 1000) return `$${(n / 1000).toFixed(1)}k`;
      return `$${Math.round(n).toLocaleString()}`;
    },
  },
};
</script>

<style scoped>
.kpi-strip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 16px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.kpi-group {
  display: flex;
  align-items: center;
  gap: 20px;
}
.kpi {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 80px;
}
.kpi--roi .kpi-value {
  color: #237804;
}
.kpi-value {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.1;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.kpi-sub {
  font-size: 13px;
  font-weight: 500;
  color: #8c8c8c;
  margin-left: 4px;
}
.kpi-label {
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 2px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.kpi-divider {
  height: 32px;
  margin: 0;
  border-color: #e9ecef;
}
.dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 999px;
}
.dot--online {
  background: #52c41a;
}
.dot--guidance {
  background: #1890ff;
}
.dot--recording {
  background: #722ed1;
}
.dot--offline {
  background: #bfbfbf;
}
@media (max-width: 768px) {
  .kpi-strip {
    flex-direction: column;
    align-items: stretch;
  }
  .kpi-group {
    justify-content: space-between;
  }
}
</style>
